export const TAGS_RESET_STATE = 'TAGS_RESET_STATE';
export const TAGS_CURRENT_ITEM = 'TAGS_CURRENT_ITEM';

export const TAGS_REQUEST_LOADING = 'TAGS_REQUEST_LOADING';
export const TAGS_REQUEST_SUCCESS = 'TAGS_REQUEST_SUCCESS';
export const TAGS_REQUEST_FAILED = 'TAGS_REQUEST_FAILED';

export const TAGS_CURRENT_ACTION = 'TAGS_CURRENT_ACTION';
export const TAGS_RESET_ACTION = 'TAGS_RESET_ACTION';